var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditNotupdateCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-notupdate-cross",
    transform: "translate(0.006 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38048",
    "data-name": "Path 38048",
    d: "M.678,14A.684.684,0,0,1,.194,12.83L12.826.2a.684.684,0,1,1,.967.967L1.161,13.8a.682.682,0,0,1-.483.2Z",
    transform: "translate(0 0)",
    fill: "#be0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38049",
    "data-name": "Path 38049",
    d: "M13.311,14a.682.682,0,0,1-.483-.2L.2,1.164A.684.684,0,0,1,1.164.2L13.795,12.83A.684.684,0,0,1,13.311,14Z",
    transform: "translate(-0.001 0)",
    fill: "#be0000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNotupdateCross);
export default __webpack_public_path__ + "static/media/edit-notupdate-cross.e1306202.svg";
export { ForwardRef as ReactComponent };